// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--19Akw";
export var hero_bg = "styles-module--hero_bg--C2_B3";
export var hero_inner = "styles-module--hero_inner--1Wq7A";
export var hero_top = "styles-module--hero_top--391uZ";
export var hero_center = "styles-module--hero_center--3I4vp";
export var hero_bot = "styles-module--hero_bot--19Xyl";
export var hero_title = "styles-module--hero_title--1aRJq";
export var hero_list = "styles-module--hero_list--2RXP7";